export const ADD_BANNER_DATA = 'ADD_BANNER_DATA';
export const REMOVE_BANNER_BY_KEY = 'REMOVE_BANNER_BY_KEY';
export const REMOVE_ALL_BANNERS = 'REMOVE_ALL_BANNERS';
